import moment from 'helpers/moment'
import React, {useContext} from 'react'

import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'

import {TeacherContext} from 'teacher/context'

import StudentAnsweredAssessmentsHead from './student-answered-assessments-head'
import StudentAnsweredAssessmentsBody from './student-answered-assessments-body'
import StudentAnsweredAssessmentsFilters from './student-answered-assessments-filters'

const useStyles = makeStyles(studentAnsweredAssessmentsStyles)

export default function StudentGradesSummary() {

  const { groupsLoaded, rollbookContextGrades: grades} = useContext(TeacherContext)
  const classes = useStyles()  

  return (
    <Box className={classes.root} > 
      <StudentAnsweredAssessmentsFilters />
      <TableContainer className={classes.container}>
        <Fade in={groupsLoaded && grades.loaded}>
          <Table className={classes.table}>
            <StudentAnsweredAssessmentsHead />
            <StudentAnsweredAssessmentsBody />
          </Table>
        </Fade>
      </TableContainer>
    </Box>
  )
}

function studentAnsweredAssessmentsStyles (theme) {
 return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: 30,
      flexGrow: 1,
      overflow: 'hidden'
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflow: 'auto',
      border: 'solid 1px #d8dbe0',
      borderTop: 0,
      [theme.breakpoints.down('xs')]: {
        border: 0
      }
    },
  }
}
